/**
 * This determines both the browser and OS platform the user is on. A data attribute is then appended to the DOM's
 * <html> tag to be used for OS and /or browser specific styling.
 * [data-os] - can be mac or win
 * [data-browser] - can be chrome, moz, or safari
 */

export const getUserPlatform = {
  init() {
    let browserType;
    const osType = navigator?.userAgent.indexOf('Mac') == -1 ? 'win' : 'mac';

    switch (true) {
      case navigator?.vendor == '':
        browserType = 'moz';
        break;

      case navigator?.vendor.indexOf('Apple') > -1:
        browserType = 'safari';
        break;

      case navigator?.vendor.indexOf('Google') > -1:
        browserType = 'chrome';
        break;
      default:
        break;
    }
    document.documentElement.setAttribute('data-os', osType);
    document.documentElement.setAttribute('data-browser', browserType);
  },
};
